module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226351841_05_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_06_int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_06_int#int-lev1"
    }
  }, [_c('em', [_vm._v("Of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_06_int#int-lev2"
    }
  }, [_c('em', [_vm._v("Of Size and Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_06_int#int-lev3"
    }
  }, [_c('em', [_vm._v("Of Nuclear Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_06_int#int-lev4"
    }
  }, [_c('em', [_vm._v("Plan of the Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1"
    }
  }, [_c('strong', [_vm._v("One")]), _vm._v(". Causes, Beginnings and Predictions: The Power Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1-lev1"
    }
  }, [_c('em', [_vm._v("Three Models")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1-lev2"
    }
  }, [_c('em', [_vm._v("Comparison of the Three Models")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1-lev3"
    }
  }, [_c('em', [_vm._v("Preparation for the Testing of a Model")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1-lev4"
    }
  }, [_c('em', [_vm._v("Empirical Tests of the Power-Distribution Models")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226351841_07_ch1#ch1-lev5"
    }
  }, [_c('em', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Two")]), _vm._v(". Davids and Goliaths: Predicting the Outcomes of International Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Power Indicators: Existing Measures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Missing Measure of Political Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Construction of a Measure of Political Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("An Index of Governmental Extraction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A New Measure of National Capabilities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tests, Hypotheses, and Findings")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_08_ch2#ch2-lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Three")]), _vm._v(". The Costs of Major Wars: The Phoenix Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theoretical Propositions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Indexing National Capabilities or Power Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Estimating Consequences of War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Choice of Test Cases")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Actors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Empirical Propositions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Findings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Phoenix Factor")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_09_ch3#ch3-lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226351841_10_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Four")]), _vm._v(". Nuclear Arms Races and Deterrence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_10_ch4#ch4-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Deterrents and Deterrence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_10_ch4#ch4-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Testing Deterrence: Outcomes of Crises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_10_ch4#ch4-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Testing Mutual Deterrence: The Nuclear Arms Race")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_10_ch4#ch4-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Five")]), _vm._v(". Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Note on Architecture")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Major Wars: Beginnings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Predictions of War Outcomes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Phoenix Factor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Deterrence and Arms Races")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_11_ch5#ch5-lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Beyond the Data")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_12_app1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Index of Political Development")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_13_app2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Postwar American Aid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_14_app3#app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Analysis of Models")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_15_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_16_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226351841_17_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c05d04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226351841_04_toc.vue
// module id = 66
// module chunks = 0